import {ApiErrors} from 'fast-sdk/src/requests/errors';
import useCreateWorkspace from 'interface/stacks/workspace/hooks/useCreateWorkspace';
import {useGetWorkspaceDetails} from 'interface/stacks/workspace/hooks/useGetWorkspaceDetails';

const DEFAULT_WORKSPACE_NAME = 'General';

const useCreateDefaultWorkspace = (subdomain: string, orgId: string) => {
  const {createWorkspace} = useCreateWorkspace();
  const {fetchWorkspaceDetails} = useGetWorkspaceDetails();

  async function createDefaultWorkspace() {
    if (!subdomain || !orgId) {
      return;
    }

    const {result, workspace, error} = await createWorkspace({
      subdomain,
      orgId,
      name: DEFAULT_WORKSPACE_NAME,
      intelligence: true,
    });

    if (
      result ||
      (error && error.code === ApiErrors.WorkspaceConfigNameInUse)
    ) {
      if (workspace) {
        await fetchWorkspaceDetails(workspace.id);
      }
      return true;
    }
  }

  return {createDefaultWorkspace};
};

export default useCreateDefaultWorkspace;
